import React from 'react';

export const Circle = () => {
	return (
		<svg viewBox='0 0 80.99 80.99'>
			{/* eslint-disable-next-line */}
			<circle cx='40' cy='40' r='30' stroke='white' strokeWidth='1' fill={'transparent'} />
		</svg>
	);
};
